import ReserveOfficePage from './ReserveOfficePage';
import Route from './route';

export default {
  RenderProp: ReserveOfficePage,
  mainRoute: Route,
};
